import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const index = () => import("@/page/index")
const detail = () => import("@/page/detail")
const theme = () => import("@/page/theme")
const comment = () => import("@/page/comment")
const enterpriser = () => import("@/page/enterpriser")

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: { title: "U1Link-ICT产业服务" }
    },{
      path: '/detail',
      name: 'detail',
      component: detail,
      meta: { title: "U1Link-ICT产业服务" }
    },{
      path: '/theme',
      name: 'theme',
      component: theme,
      meta: { title: "U1Link-ICT产业服务" }
    },{
      path: '/comment',
      name: 'comment',
      component: comment,
      meta: { title: "U1Link-ICT产业服务" }
    },{
      path: '/enterpriser',
      name: 'enterpriser',
      component: enterpriser,
      meta: { title: "U1Link-ICT产业服务" }
    }
  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js